import { render, staticRenderFns } from "./InvestmentsHome.vue?vue&type=template&id=3d893224&scoped=true"
import script from "./InvestmentsHome.vue?vue&type=script&lang=js"
export * from "./InvestmentsHome.vue?vue&type=script&lang=js"
import style0 from "./InvestmentsHome.vue?vue&type=style&index=0&id=3d893224&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d893224",
  null
  
)

export default component.exports